import styled from 'styled-components'

const WrapFilterMoneyPayments = styled.div`
    position: relative;
`;

export {
    WrapFilterMoneyPayments
}